export const ExperimentTitleNames = {
  ArticleAdDensity: "Article Ad Density",
  ContextualPaywallMessaging: "Contextual Paywall Messaging",
  HigherPaywall: "Higher Paywall",
  LTSHardPaywall: "LTS 70 Hard Paywall",
  PaywallMasking: "Paywall Masking",
  Proteus: "Proteus",
};

export const ExperimentAPINames = {
  ArticleAdDensity: "article_ad_density",
};
